import { ProductType } from '~/types/product';

export const ONE_SIZE = 'One Size';
export const COLOR = 'Color';
export const SIZE = 'Size';

export const MYSTERY_DROP_COLLECTIONS = [
  'Star People',
  'Space Madness',
  'Alternate Dimensions',
  'Universal Laws',
];

export const SIZE_ABBREVIATIONS_IN_WAIST_LENGTH_MAP = {
  'W26/L28': 'W26/L28',
  'W28/L30': 'W28/L30',
  'W30/L32': 'W30/L32',
  'W32/L32': 'W32/L32',
  'W34/L32': 'W34/L32',
  'W36/L32': 'W36/L32',
  'W38/L32': 'W38/L32',
  'W40/L32': 'W40/L32',
};

export const SIZE_ABBREVIATIONS_MAP = {
  ...SIZE_ABBREVIATIONS_IN_WAIST_LENGTH_MAP,
  'X-SMALL': 'XS',
  SMALL: 'S',
  MEDIUM: 'M',
  LARGE: 'L',
  'X-LARGE': 'XL',
  'XX-LARGE': 'XXL',
};

export const PRODUCT_INDICES = {
  [ProductType.Hoodie.toString()]: 0,
  [ProductType.StraightLegSweatpants.toString()]: 1,
  [ProductType.Jersey.toString()]: 2,
  [ProductType.MeshShorts.toString()]: 3,
  [ProductType.CargoPants.toString()]: 4,
  [ProductType.CottonTrackTop.toString()]: 5,
  [ProductType.DenimShorts.toString()]: 6,
  [ProductType.TShirt.toString()]: 7,
  [ProductType.BabyTee.toString()]: 8,
  [ProductType.ZipUp.toString()]: 9,
  [ProductType.Shorts.toString()]: 10,
  [ProductType.CuffedSweatpants.toString()]: 11,
  [ProductType.WaffleBeanie.toString()]: 12,
  [ProductType.Boxers.toString()]: 13,
  [ProductType.LightWeightTank.toString()]: 14,
  [ProductType.MensTankTop.toString()]: 15,
  [ProductType.SweatShorts.toString()]: 16,
  [ProductType.WorkwearJacket.toString()]: 17,
  [ProductType.RacerKnit.toString()]: 18,
  [ProductType.WideLegDenim.toString()]: 19,
  [ProductType.PolarFleece.toString()]: 20,
  [ProductType.Puffer.toString()]: 21,
  [ProductType.VelourTrackJacket.toString()]: 22,
  [ProductType.VelourTrackPants.toString()]: 23,
  [ProductType.Cap.toString()]: 24,
  [ProductType.StarCamoBeanie.toString()]: 25,
  [ProductType.NewPolarFleece.toString()]: 26,
  [ProductType.DenimWorkwearJacket.toString()]: 27,
  [ProductType.DenimJeans.toString()]: 28,
  [ProductType.VarsityJacket.toString()]: 29,
  [ProductType.PixelStarBeanie.toString()]: 30,
  [ProductType.TopLeagueTrackJacket.toString()]: 31,
  [ProductType.TopLeagueTrackPants.toString()]: 32,
  [ProductType.FoldoverBeanie.toString()]: 33,
  [ProductType.Knitwear.toString()]: 34,
  [ProductType.FauxFurZipUpHoodie.toString()]: 35,
  [ProductType.WideSweatpants.toString()]: 36,
  [ProductType.TrackTop.toString()]: 37,
  [ProductType.TrackPants.toString()]: 38,
  [ProductType.NewHoodieShape.toString()]: 39,
  [ProductType.MeshLayeredTShirt.toString()]: 40,
  [ProductType.VelourSweatpants.toString()]: 41,
  [ProductType.CroppedZipUp.toString()]: 42,
  [ProductType.WomensTankTop.toString()]: 43,
  [ProductType.LongSleeveWaffle.toString()]: 44,
  [ProductType.RacerJacket.toString()]: 45,
  [ProductType.FootballJersey.toString()]: 46,
  [ProductType.WomensOneShoulderTop.toString()]: 47,
  [ProductType.WomensFootballJersey.toString()]: 48,
  [ProductType.HalterTop.toString()]: 49,
  [ProductType.FootballMeshShorts.toString()]: 50,
  [ProductType.DenimSkirt.toString()]: 51,
  [ProductType.CroppedBoxyTShirt.toString()]: 52,
  [ProductType.SwimmingShorts.toString()]: 53,
  [ProductType.LoungeCorset.toString()]: 54,
  [ProductType.WomensShorts.toString()]: 55,
  [ProductType.CamoBikini.toString()]: 56,
  [ProductType.RibbedTankTopSizes.toString()]: 57,
  [ProductType.Sweatpants.toString()]: 58,
  [ProductType.PerformanceTShirt.toString()]: 59,
  [ProductType.SweatSkirt.toString()]: 60,
  [ProductType.ButtonUpShirt.toString()]: 61,
  [ProductType.DenimJacket.toString()]: 62,
  [ProductType.SlinkySkirt.toString()]: 63,
  [ProductType.MensWashedRibbedZipUp.toString()]: 64,
  [ProductType.WomensWhashedRibbedZipUp.toString()]: 65,
  [ProductType.RibbedTankTopSizesWoman.toString()]: 66,
  [ProductType.WashedSkirt.toString()]: 67,
  [ProductType.RipstopCamoSkirt.toString()]: 68,
  [ProductType.DenimCorsetTop.toString()]: 69,
  [ProductType.CamoThermallongSleeve.toString()]: 70,
  [ProductType.TankTop.toString()]: 71,
  [ProductType.Crewneck.toString()]: 72,
  [ProductType.CombatPants.toString()]: 73,
  [ProductType.LongSleeve.toString()]: 74,
  [ProductType.TechJacket.toString()]: 75,
  [ProductType.TechPants.toString()]: 76,
  [ProductType.ToteBag.toString()]: 77,
  [ProductType.Sunglasses.toString()]: 78,
  [ProductType.Socks.toString()]: 79,
};
